import { create } from 'zustand';
import { getSessionIdApi, getSessionListApi, getSessionMessageApi, feedbackSessionApi, deleteSessionApi } from '@/api/headChatBot';

type SessionListStore = {
  isLoadingNewSessionId: boolean;
  setIsLoadingNewSessionId: (isLoadingNewSessionId: boolean) => void;
  // 
  sessionList: any[];
  setSessionList: (sessionList: any[]) => void;
  isLoadingSessionList: boolean;
  setIsLoadingSessionList: (isLoadingSessionList: boolean) => void;
  reQuerySessionListData: (params?: any) => void;
  // 
  currentSessionMessage: any[];
  setCurrentSessionMessage: (currentSessionMessage: any) => void;
  isLoadingSessionMessage: boolean;
  setIsLoadingSessionMessage: (isLoadingSessionMessage: boolean) => void;
  reQuerySessionMessageData: (params?: any) => void;
  // 
  currentSessionObj: any;
  setCurrentSessionObj: (currentSessionObj: any) => void;
  currentSessionId: string;
  setCurrentSessionId: (currentSessionId: string) => void;
  //
  messageHistory: any;
  setMessageHistory: (messageHistory: any) => void;
  // 
  chatSetMessagesFunctionAgent: Function;
  setChatSetMessagesFunctionAgent: (chatSetMessagesFunctionAgent: Function) => void;
  chatSetMessagesFunctionDna: Function;
  setChatSetMessagesFunctionDna: (chatSetMessagesFunctionDna: Function) => void;
  //
  chatSetOnRequestFunctionAgent: Function;
  setChatSetOnRequestFunctionAgent: (chatSetOnRequestFunctionAgent: Function) => void;
  chatSetOnRequestFunctionDna: Function;
  setChatSetOnRequestFunctionDna: (chatSetOnRequestFunctionDna: Function) => void;
  // 
  shareTitle: string;
};


const reQuerySessionListData = async (params?: any) => {
  // [{
  //   key: "default-2",
  //   label: "New AGI hybrid interface",
  //   group: "Previous",
  // }]
  const { andLoading = true, sessionId } = params || {};
  // 重新进入 置空
  if (andLoading) {
    useSessionListStore.setState({ isLoadingSessionList: true });
    useSessionListStore.setState({ sessionList: [] });
  }
  // 
  getSessionListApi().then(async (data) => {
    const sessionList = data.map((el: any) => {
      return {
        ...el,
        key: el.sessionId,
        label: el.title,
        // group: el.group,
      }
    })
    useSessionListStore.setState({ sessionList });

    if (!useSessionListStore.getState().currentSessionId) {
      if (sessionList?.length && sessionList[0].sessionId) {
        useSessionListStore.setState({ currentSessionId: sessionList[0].sessionId });
        reQuerySessionMessageData({ sessionId: sessionList[0].sessionId });
      } else {
        // 创建第一条
        useSessionListStore.setState({ isLoadingNewSessionId: true });
        try {
          const res = await getSessionIdApi({ type: "head" });
          const newSessionId = res.sessionId;
          const newSessionList = [
            {
              key: newSessionId,
              label: `new conversation`,
              tempSessionId: true,
            },
          ];
          useSessionListStore.setState({ sessionList: newSessionList });
          useSessionListStore.setState({ currentSessionId: newSessionId });
        } catch (error) {
          console.error(error);
        } finally {
          useSessionListStore.setState({ isLoadingNewSessionId: false });
        }
      }
    } else {
      if (!sessionList?.find((el: any) => el.key === useSessionListStore.getState().currentSessionId)) {
        useSessionListStore.setState({ currentSessionId: sessionList[0].sessionId });
      }
    }


    useSessionListStore.setState({ isLoadingSessionList: false });
  }).catch((error) => {
    useSessionListStore.setState({ isLoadingSessionList: false });
    console.error(error);
  });
}

const reQuerySessionMessageData = async (params?: any) => {
  const { andLoading = true, sessionId } = params || {};
  // 重新进入 置空
  if (andLoading) {
    useSessionListStore.setState({ isLoadingSessionMessage: true });
    useSessionListStore.setState({ currentSessionMessage: [] });
  }
  // 
  getSessionMessageApi(sessionId).then((data) => {

    useSessionListStore.setState({
      shareTitle: data?.title,
      currentSessionMessage: data?.history?.map((el: any) => {
        // [{
        //   id: "msg_0",
        //   message: {
        //     message_id: "message_id_01",
        //     role: "user",
        //     content: "写个 特别短的 react 组件",
        //   },
        //   status: "local",
        // }]
        return {
          id: el.message_id,
          message: el,
          // status: "local"
        }
      }) || []
    });
    useSessionListStore.setState({ isLoadingSessionMessage: false });
  }).catch((error) => {
    useSessionListStore.setState({ isLoadingSessionMessage: false });
    console.error(error);
  });
}

export const useSessionListStore = create<SessionListStore>((set, get) => ({
  isLoadingNewSessionId: false,
  setIsLoadingNewSessionId: (isLoadingNewSessionId: boolean) => set({ isLoadingNewSessionId }),
  // 
  sessionList: [],
  setSessionList: (sessionList: any) => set({ sessionList }),
  isLoadingSessionList: false,
  setIsLoadingSessionList: (isLoadingSessionList: boolean) => set({ isLoadingSessionList }),
  reQuerySessionListData,
  // 
  currentSessionMessage: [],
  setCurrentSessionMessage: (currentSessionMessage: any) => set({ currentSessionMessage }),
  isLoadingSessionMessage: false,
  setIsLoadingSessionMessage: (isLoadingSessionMessage: boolean) => set({ isLoadingSessionMessage }),
  reQuerySessionMessageData,
  //
  currentSessionObj: {},
  setCurrentSessionObj: (currentSessionObj: any) => set({ currentSessionObj }),
  currentSessionId: '',
  setCurrentSessionId: (currentSessionId: string) => {
    set({ currentSessionId });
  },
  //
  messageHistory: {},
  setMessageHistory: (messageHistory: any) => set({ messageHistory }),
  // 
  chatSetMessagesFunctionAgent: () => { },
  setChatSetMessagesFunctionAgent: (chatSetMessagesFunctionAgent: Function) => set({ chatSetMessagesFunctionAgent }),
  chatSetMessagesFunctionDna: () => { },
  setChatSetMessagesFunctionDna: (chatSetMessagesFunctionDna: Function) => set({ chatSetMessagesFunctionDna }),
  //
  chatSetOnRequestFunctionAgent: () => { },
  setChatSetOnRequestFunctionAgent: (chatSetOnRequestFunctionAgent: Function) => set({ chatSetOnRequestFunctionAgent }),
  chatSetOnRequestFunctionDna: () => { },
  setChatSetOnRequestFunctionDna: (chatSetOnRequestFunctionDna: Function) => {
    // console.log('hans-2chatSetOnRequestFunctionDna', chatSetOnRequestFunctionDna);
    set({ chatSetOnRequestFunctionDna });
  },
  //
  shareTitle: '',
}));
